<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
created() {
      var html = document.getElementsByTagName("html")[0];
      if(window.innerWidth < 768){
          
          html.style.fontSize = window.innerWidth/750*100 + "px";
          // console.log(window.innerWidth/750*100 + "px");
        }else{
          html.style.fontSize = "16px"
        }

        window.addEventListener('load', function() {
  
          window.addEventListener('resize', function() {
            if(window.innerWidth < 768){
              html.style.fontSize = window.innerWidth/750*100 + "px";
              // console.log(window.innerWidth/750*100 + "px");
            }else{
              html.style.fontSize = "16px"
            }
          })
        })
   }
}

</script>
<style>
  @media screen and (max-width: 767px){
      body,html,#app{
        margin: 0;
        padding: 0;
        width: 100%;
        min-width: 100px;
      }
      #app{
        font-size: 0rem;
      }
  }
</style>
